<template>
  <div class="nav-item" :class="{cur: option.selected}">
    <router-link :to="option.path">
      <slot>
        <div class="icon-box">
          <i class="iconfont" :class="'icon-'+option.icon"></i>
          <t-badge v-if="option.number" class="num" :text="option.number"></t-badge>
        </div>
        <p>{{option.text}}</p>
      </slot>
    </router-link>
  </div>
</template>
<script>
import tBadge from './badge.vue';

/**
 * @param option [Object] 参数包含path(跳转地址),icon(图标)，text(标题),selected(是否选中)，number(数量角标)
 * @describe 底部导航组件
 *
 * @example
 *
  <t-navbar>
    <t-navitem :option="{path: 'home' icon: 'home', text: '首页', selected: true }"></t-navitem>
    <t-navitem :option="{path: 'home' icon: 'home', text: '分类', selected: false }"></t-navitem>
    <t-navitem :option="{path: 'home' icon: 'home', text: '购物车', selected: false }"></t-navitem>
    <t-navitem :option="{path: 'home' icon: 'home', text: '我的', selected: false }"></t-navitem>
  </t-navbar>
 */
export default {
  name: 'tNavitem',

  props: {
    option: Object,
    // path: 跳转地址
    // icon: 图标
    // number: 数量
    // text: 文字
    // selected: 是否选中
  },
  components: { tBadge },
};

</script>
<style lang="scss">
.nav-item {
  flex: 1;
  .icon-box {
    text-align: center;
    padding-top: 8px;
    position: relative;
  }
  .num {
    position: absolute;
    top: 5px;
    left: 60%;
  }
  i {
    color: #b2b2b2;
    font-size: 20px;
  }
  p {
    color: #b2b2b2;
    font-size: 12px;
    line-height: 18px;
  }
  &.cur {
    i {
      color: #f4b357;
    }
    p {
      color: #f4b357;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/navitem.vue